import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output,ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import * as _ from 'lodash';
import { NbDialogService } from '@nebular/theme';
import { EditMetadataService } from './edit-metadata.services';
import { NbTagComponent, NbTagInputAddEvent } from '@nebular/theme';

@Component({
  selector: 'edit-metadata',
  templateUrl: './edit-metadata.component.html',
  styleUrls: ['./edit-metadata.component.scss']
})
export class EditMetadataComponent implements OnInit, AfterViewInit {

   @ViewChild("editmetadataForm") editmetadataForm: any;

   @Input() id = null;
   @Input() fromheight = null;

   @Output() saveButtonClick = new EventEmitter<any>();
   @Output() cancelButtonClick = new EventEmitter<any>();

   submitted: boolean; 
   _data:{
    title: string;
    tag: string;
    description: string;
  };

  tags: string[] = [];
  tagJson: string = '';
  maxTags = 5;
  maxLength = 200;
  tagError: string | null = null;

  from_height: any = 'vh60';

   constructor(
      private router: Router,
      private route: ActivatedRoute,
      private location: Location,
      private _toastr: ToastrService,
      private dialogService: NbDialogService,
      private editMetadataService: EditMetadataService
    ) { 
      this._data = { title: "", tag: "", description: "" };
    }

    ngOnInit(): void {
      this.from_height = this.fromheight;
      this.LoadData();
    }
  
    ngAfterViewInit(): void {
  
    }

    LoadData() {
      if (!this.id) return;

      this.editMetadataService.getMetadata(this.id).subscribe(
        (res: any) => {

          if (!res.status) {
            this._toastr.error(res.message);
            return;
          }

          const data = res.data;

          this._data = {
            title: data.title,
            tag: data.tag,
            description: data.description
          };

          this.loadTags(data.tag);

        },
        (err) => {
          this._toastr.error(err.message);
        }
      );
    }
  
    Save(form,isValid){
      this.submitted = true;
  
      if (!isValid) return;

      form.id = this.id;
      form.name =  this._data.title;

      const jsonTags = this.tags?.length ? JSON.stringify(this.tags) : null;
      if (jsonTags && jsonTags.length > this.maxLength) {
        this.tagError = 'Total of tag length must not exceed 200 characters.';
        return;
      }

      const formPayload = {
        id: this.id,
        name: this._data.title,
        tag: jsonTags,
        title: this._data.title,
        description: this._data.description
      };

      form.tag = jsonTags;
      form.description =  this._data.description;

      this.editMetadataService.UpdateMetaData(formPayload).subscribe((res) => {
        if (!res.status) {
          this._toastr.error("Unable to update metadata! An unexpected error has occurred.");
          return;
        }

        this._data.tag = jsonTags;
        this.tags = [...this.tags];

        this._toastr.success("Metadata updated successfully.");
        this.saveButtonClick.emit();
      });
    
    }

    onCancel() {
      this.cancelButtonClick.emit();
    }

    preventEnter(event: KeyboardEvent) {
      event.preventDefault();
    }

    onTagAdd({ value, input }: NbTagInputAddEvent): void {
      const trimmed = value?.trim();
      if (!trimmed) return;

      // limit 20 characters per tag
      if (trimmed.length > 20) {
        this.tagError = 'Each tag must not exceed 20 characters.';
        input.nativeElement.value = '';
        return;
      }

      // duplicate
      if (this.tags.includes(trimmed)) {
        this.tagError = 'Duplicate tag is not allowed.';
        input.nativeElement.value = '';
        return;
      }

      // max 5 tags
      if (this.tags.length >= this.maxTags) {
        this.tagError = 'Maximum 5 tags allowed.';
        input.nativeElement.value = '';
        return;
      }

      const temp = [...this.tags, trimmed];
      const json = JSON.stringify(temp);

      // total 200 chars
      if (json.length > this.maxLength) {
        this.tagError = 'Total of tag length must not exceed 200 characters.';
        input.nativeElement.value = '';
        return;
      }

      this.tags = temp;
      this.tagJson = json;
      this.tagError = '';

      input.nativeElement.value = '';
    }

    clearTagError() {
      this.tagError = '';
    }

    onTagRemove(tagToRemove: NbTagComponent): void {
      this.tags = this.tags.filter(t => t !== tagToRemove.text);
      this.tagJson = this.tags.length ? JSON.stringify(this.tags) : null;

      // re-check length
      if (this.tagJson && this.tagJson.length > this.maxLength) {
        this.tagError = 'Total of tag length must not exceed 200 characters.';
      } else {
        this.tagError = '';
      }
    }

    loadTags(tagString: string | null): void {
      if (!tagString) {
        this.tags = [];
        return;
      }

      try {
        const parsed = JSON.parse(tagString);
        this.tags = Array.isArray(parsed) ? parsed : [];
      } catch {
        this.tags = [];
      }
    }
}